import { createStyles, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

const marginLeftDefault = "2.4%";
const useStylesHome = makeStyles((theme: Theme) =>
  createStyles({
    containerSection: {
      maxWidth: "97.6%",
      width: "97.6%",
      marginLeft: "1.4%",
      justifyContent: "space-between",
    },
    imgHome: {
      width: "100%",
      height: "100%",
      "& img": {
        width: "50%",
      },
    },
    link: {
      textDecoration: "none",
      fontSize: "2.4rem",
    },
    section: {
      marginTop: "4.8rem",
      "& h6": {
        marginTop: "0.8rem",
      },
    },
    firstSection: {
      marginTop: "0.8rem",
      "& h6": {
        marginTop: "0.8rem",
      },
    },

    paper: {
      padding: theme.spacing(2),
      border: "none",
      width: "100%",
    },
    paperMobile: {
      paddingLeft: 0,
      border: "none",
      width: "100%",
    },
    news: {
      padding: 0,
      border: "none",
      marginRight: 0,
      textAlign: "right",
      height: "354px",
    },

    title: {
      fontFamily: "Montserrat",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "56px",
      color: "#3E3D3D",
      paddingBottom: "30px",
      paddingTop: theme.spacing(0.6),
    },
    titleSection: {
      fontFamily: "DM Sans",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "22px",
      lineHeight: "31px",
      color: "#3E3D3D",
      paddingLeft: 0,
    },
    titleSectionMobile: {
      fontFamily: "DM Sans",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "21px",
      color: " #3E3D3D",
      paddingLeft: "8px",
    },
    subtitleSection: {
      fontFamily: "Montserrat",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#3E3D3D",
      opacity: 0.7,
    },
    containerTitle: {
      maxWidth: "98.6%",
      width: "98.6%",
      marginLeft: marginLeftDefault,
      justifyContent: "space-between",
      paddingLeft: theme.spacing(2),
    },
    containerOptions: {
      maxWidth: "98.6%",
      width: "98.6%",
      margin: "0 auto",
      display: "flex",
      flexWrap: "nowrap",
      justifyContent: "center",
      gap: theme.spacing(3),
      padding: theme.spacing(2),
      height: "auto",
    },
    cardTitle: {
      display: "flex",
      marginLeft: "20px",
    },
    linkOrdersUnderTable: {
      fontFamily: "Montserrat",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#D91F05",
      spacing: 12,
    },
    linkTitlesUnderTable: {
      fontFamily: "Montserrat",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "15px",
      lineHeight: "20px",
      color: "#D91F05",
      width: "100%",
      marginBottom: "50px",
    },
    msgEmptyTitles: {
      fontFamily: "Montserrat",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "20px",
      color: "#3E3D3D",
      opacity: 0.7,
      marginBottom: "50px",
      marginLeft: "20px",
    },
    button: {
      width: "100%",
      textTransform: "inherit",
      padding: 5,
      transition: "all 0.3s ease-in-out",
      "&:hover": {
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
        borderRadius: 10,
      },
    },
  })
);

export default useStylesHome;
